(() => {
  if (window.HabbysPdpReviews) return;

  const selector = '[data-hh-pdp-rating]';
  const initialized = new WeakSet();
  let batch = 0;

  function initialize(root = document) {
    if (typeof window.ratingSnippet !== 'function') return;
    const nodes = [...root.querySelectorAll(selector)];
    if (root.matches?.(selector)) nodes.unshift(root);
    const groups = new Map();

    nodes.forEach((node) => {
      if (initialized.has(node) || !node.isConnected || !node.dataset.store || !node.dataset.sku) return;
      const key = JSON.stringify([node.dataset.store, node.dataset.reviewText || '']);
      if (!groups.has(key)) groups.set(key, []);
      groups.get(key).push(node);
    });

    groups.forEach((group) => {
      const className = `hh-pdp-rating-batch-${++batch}`;
      group.forEach((node) => {
        initialized.add(node);
        node.classList.add(className);
      });
      try {
        window.ratingSnippet(className, {
          store: group[0].dataset.store,
          color: '#0E1311',
          linebreak: true,
          usePolaris: true,
          text: group[0].dataset.reviewText || '',
          listenForChanges: false,
          showEmptyStars: false
        });
      } catch (error) {
        group.forEach((node) => {
          initialized.delete(node);
          node.classList.remove(className);
        });
        console.error('[Habbys ratings]', error);
      }
    });
  }

  function start() {
    initialize();
    const observer = new MutationObserver((mutations) => {
      const hasNewRating = mutations.some((mutation) =>
        [...mutation.addedNodes].some((node) => node.nodeType === Node.ELEMENT_NODE &&
          (node.matches(selector) || node.querySelector(selector)))
      );
      if (hasNewRating) initialize();
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  window.HabbysPdpReviews = { initialize };
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  window.addEventListener('load', () => initialize(), { once: true });
  const script = document.querySelector('script[src*="widget.reviews.io/rating-snippet/dist.js"]');
  script?.addEventListener('load', () => initialize(), { once: true });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
